import { Box, Grid, Paper, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { useEffect } from "react";
import AppTextareaInput from "../../components/AppTextareaInput";
import MembershipFormModel from "./membershipFormModel";
import { useAppSelector } from "../../store/configureStore";
import AppAutocomplete from "../../components/AppAutocomplete";
import { MapCountriesToAutocompleteItems } from "../../utils/convertStaticDataToAutocompleteItems";

export default function MemberPostalAddress() {
    const methods = useFormContext();
    const { control, reset } = methods;

    const {
        formField: {
            PostalAddressLines,
            PostalAddressCountry
        }
    } = MembershipFormModel;

    const { countries } = useAppSelector(state => state.ReferenceData);
    const { personalDetails } = useAppSelector(state => state.personalDetail);

    useEffect(() => {
        if (personalDetails !== undefined && personalDetails !== null && countries && countries?.length > 0) {

            reset({
                [PostalAddressLines.name]: (personalDetails.postalAddress === null ||
                    personalDetails.postalAddress === undefined) ? '' : personalDetails.postalAddress,
                [PostalAddressCountry.name]: (personalDetails.postalAddressCountryId === null ||
                    personalDetails.postalAddressCountryId === undefined) ? '' : personalDetails.postalAddressCountryId
            })
        }
    }, [personalDetails, countries, reset]);

    return <>
        <Box sx={{ width: "100%" }} component={Paper}>
            <Grid container rowSpacing={4} sx={{ margin: "2%" }}>

                <Grid size={{ xs: 12 }}></Grid>

                <Grid size={{ xs: 12 }}>
                    <Typography variant='subtitle1' sx={{ fontWeight: "500" }}>Postal address</Typography>
                    <Typography variant="subtitle1" sx={{ color: 'primary.main' }}>
                        {PostalAddressLines.information_text}
                    </Typography>
                </Grid>

                <Grid size={{ xs: 12 }}>
                    <AppTextareaInput control={control} name={PostalAddressLines.name}
                        label={PostalAddressLines.label} maxStringCount={PostalAddressLines.maxStringCount} />
                </Grid>

                <Grid size={{ xs: 12 }}>
                    <AppAutocomplete control={control} name={PostalAddressCountry.name}
                        label={PostalAddressCountry.label} items={MapCountriesToAutocompleteItems(countries ?? [])} />
                </Grid>

                <Grid size={{ xs: 12 }}></Grid>

            </Grid>
        </Box>
    </>
}